import React from 'react';
import styled from '@emotion/styled';

interface SkeletonBlockProps {
  width: string;
  height: string;
}

const SkeletonBlock = styled.div<SkeletonBlockProps>`
  background-color: ${({ theme }) => theme.palette.greyGrey4};
  border-radius: 4px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;

const SkeletonButton = () => <SkeletonBlock height="40px" width="120px" />;

const JobInfoSkeleton = () => {
  return (
    <SkeletonContainer>
      <Header>
        <SkeletonBlock height="100px" width="100px" />
        <div>
          {' '}
          <SkeletonBlock height="24px" width="30%" />
          <SkeletonBlock height="18px" width="60%" />
          <SkeletonBlock height="18px" width="90%" />
        </div>
      </Header>

      <Body>
        <SkeletonBlock height="14px" width="100%" />
        <SkeletonBlock height="14px" width="100%" />
        <SkeletonBlock height="14px" width="80%" />
        <SkeletonBlock height="14px" width="90%" />
        <SkeletonBlock height="14px" width="60%" />
      </Body>

      <SkeletonButtonRow>
        <SkeletonButton />
        <SkeletonButton />
      </SkeletonButtonRow>
    </SkeletonContainer>
  );
};

export default JobInfoSkeleton;

// Styled components
const SkeletonContainer = styled.div`
  border-radius: 6px;
  display: grid;
  gap: 24px;
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;

  @media (max-width: 540px) {
    border-radius: 0;
    border: none;
  }
`;

const Header = styled.div`
  display: flex;
  gap: 12px;

  & > div:nth-of-type(1) {
    @media (max-width: 540px) {
      width: 50px;
      height: 50px;
    }
  }

  & > div:nth-of-type(2) {
    flex-grow: 1;

    & > div {
      margin-bottom: 1rem;
    }
  }
`;

const Body = styled.div`
  display: grid;
  gap: 8px;
`;

const SkeletonButtonRow = styled.div`
  display: flex;
  gap: 1rem;
`;
